/**
 * The `?budget=` search parameter as a budget id: a positive safe integer made of digits only, else
 * `null`. A `null` (absent or malformed) never reaches the API — the tab then selects the first budget
 * of the list, and an id is only fetched once it is known to be in that list.
 */
export function parseBudgetId(raw: string | null | undefined): number | null {
  if (raw === null || raw === undefined || !/^\d+$/.test(raw)) {
    return null;
  }
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
